import React from 'react';
import PropTypes from 'prop-types';
import Header from 'cccisd-header';
import style from './style.css';

const NavBar = ({ className }) => {
    return (
        <div className={`${style.navbar}`}>
            <Header containerClassName={className} wrapperClassName={style.wrapper} logoClassName={style.logo} />
        </div>
    );
};

NavBar.defaultProps = {
    className: 'container-fluid',
};

NavBar.propTypes = {
    className: PropTypes.string,
};

export default NavBar;
